/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
/* eslint-disable arrow-parens -- needed */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@americanexpress/one-app-router';
import { IconChevronRight } from '@americanexpress/dls-icons';
import AnalyticsClick from '../../../../shared/components/analyticsClick';

const style = {
  'max-width': '500px',
  'max-height': '300px',
};

const createDetailsPageLink = link => {
  if (global.BROWSER) {
    return `${window.location.origin}/card-benefits/${link}`;
  }
  return '';
};

const extractAndCreateDetailsPageLinkFromChild = child => createDetailsPageLink(
  child.props?.pageLinkRoute?.split('/card-benefits/')[1]
);

const MobileLayout = ({ children }) => {
  if (!children) {
    throw new Error('This layout expects children');
  }
  return (
    <div style={style}>
      <AnalyticsClick element="mobile-layout>>card-tile">
        <Link to={extractAndCreateDetailsPageLinkFromChild(children[0])}>
          <hr />
          <div className="row">
            <div className="col-md-12 pad-1-t pad-2-l">
              {React.cloneElement(children[1], {
                title: children[1].props.title,
                shortDescription: '',
              })}
              <IconChevronRight size="md" color="brand" className="float-right margin-2-r margin-2-b" />
            </div>
          </div>
          <hr />
        </Link>
      </AnalyticsClick>
    </div>
  );
};

MobileLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MobileLayout;
